
 import {Icons } from './style'

  const Starts = ({className}) => {
    return (
        <div className={className}>

      <div className='w-[70px] h-4 flex justify-around'>
          <Icons.Yulduz></Icons.Yulduz>
          <Icons.Yulduz></Icons.Yulduz>
          <Icons.Yulduz></Icons.Yulduz>
          <Icons.Yulduz></Icons.Yulduz>
          <Icons.Yulduz></Icons.Yulduz>
      </div>
        </div>
    )
  }
  export default Starts